import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { CrmUser } from '../admin/models/installer';
import { buList } from '../shared/i18n/i18n.config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function implementsCrmUser(object: any): object is CrmUser {
    return 'crmId' in object && 'businessUnit' in object;
}

// https://gomakethings.com/how-to-check-if-two-arrays-are-equal-with-vanilla-js/
/**
 * Check if 2 different arrays (not the same reference) contains the same values in the same order
 * @param arr1 {string[] | number[] | boolean []}
 * @param arr2 {string[] | number[] | boolean []}
 */
export function arraysMatch(arr1: string[] | number[] | boolean[], arr2: string[] | number[] | boolean[]) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) {
        return false;
    }

    // Check if all items exist and are in the same order
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    // Otherwise, return true
    return true;
}

// https://stackoverflow.com/a/54126828
export function isFormGroup(control: AbstractControl): control is UntypedFormGroup {
    return !!(<UntypedFormGroup>control).controls;
}

// slightly modified to return array instead of object
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function collectErrors(control: AbstractControl): any | null {
    if (!isFormGroup(control)) {
        return control.errors;
    }

    return Object.entries(control.controls).reduce((acc, [key, childControl]) => {
        const childErrors = collectErrors(childControl);
        if (childErrors) {
            // acc = {...acc, [key]: childErrors};
            acc = [...acc, { name: key, errors: childErrors }];
        }
        return acc;
    }, []);
}

export function getInstallerCountryFromBUCode(country: string): string {
    const foundBU = buList.find((bu) => bu.value === country.toUpperCase());
    if (foundBU) {
        return foundBU.viewValue;
    }
    return '';
}

export function checkQRCodeString(str: string): boolean {
    const REMOTE_QR_CODE_LENGHT_SITUO = 56;
    const REMOTE_QR_CODE_LENGHT_KEYGO = 40;
    const regExp = new RegExp(/^[0-9A-F\r\n]+$/);
    return (
        regExp.test(str) && (str.length === REMOTE_QR_CODE_LENGHT_KEYGO || str.length === REMOTE_QR_CODE_LENGHT_SITUO)
    );
}
